import { useState } from "react";

import { useTranslation } from "react-i18next";

import { DropdownValue } from "components/Actions/dialogs/types/interfaces";
import Dialog from "components/DesignComponents/Dialog";
import {
    ENDPOINT_PATH_SEGMENTS,
    ENDPOINTS,
    useApi,
    useMediaQueries
} from "shared";

import { DeviceTransferModalProps, TRANSFER_DEVICE_WINDOWS } from "../../types";
import ReceiveDeviceActions from "./ReceiveDeviceActions";
import ReceiveDeviceContent from "./ReceiveDeviceContent";

const ReceiveDevice = ({
    isOpen,
    close,
    changeDialogWindow,
    modalCSS
}: DeviceTransferModalProps) => {
    const { handleResponse, postData } = useApi();

    const { t } = useTranslation();
    const { toMd } = useMediaQueries();

    const [isLoading, setIsLoading] = useState(false);
    const [receiveToken, setReceiveToken] = useState(null);
    const [company, setCompany] = useState<DropdownValue | null>(null);

    const handleCompanyChange = (value: DropdownValue | null) =>
        setCompany(value);

    const generateToken = async () => {
        try {
            setIsLoading(true);

            const { data } = await postData(
                `${ENDPOINTS.Tokens}${ENDPOINT_PATH_SEGMENTS.DeviceTransferToken}`,
                { company_id: company?.id }
            );

            setReceiveToken(data.token);
        } catch (error) {
            handleResponse(error);
        }

        setIsLoading(false);
    };

    return (
        <Dialog
            data-testid="receive-devices-dialog"
            title={t("Button##receive devices")}
            description={
                !receiveToken
                    ? t("Dialog##device transfer##receive devices##description")
                    : t("Dialog##device transfer##receive devices##copy token")
            }
            isTitleSeparator
            isActionsSeparator
            open={isOpen}
            close={close}
            submit={generateToken}
            actions={
                <ReceiveDeviceActions
                    loading={isLoading}
                    token={receiveToken}
                    company={company}
                    close={close}
                    goToMainScreen={() =>
                        changeDialogWindow(TRANSFER_DEVICE_WINDOWS.Main)
                    }
                />
            }
            css={modalCSS}
            extendToMaxWidth={toMd}
            slotProps={{
                transition: {
                    onExited: () => {
                        setReceiveToken(null);
                        setCompany(null);
                        changeDialogWindow(TRANSFER_DEVICE_WINDOWS.Main);
                    }
                }
            }}
        >
            <ReceiveDeviceContent
                token={receiveToken}
                onCompanyChange={handleCompanyChange}
            />
        </Dialog>
    );
};
export default ReceiveDevice;
